import { WarningStep } from "#/components/carrot-card-cost-share/steps/variants/WarningStep"
import { Link } from "@carrotfertility/carotene-core"
import React, { useContext } from "react"
import { useIntl } from "react-intl"
import { Link as RouterLink } from "react-router-dom"
import { DbgPaths } from "#/utils/Paths"
import { CarrotCardCostSharePreAuthContext } from "#/components/carrot-card-cost-share/state/CarrotCardCostSharePreAuthContext"
import { JourneyTypes } from "#/components/get-reimbursed/steps/ExpenseJourneyTypes"

const journeyEligibleExpensesPaths: Partial<Record<JourneyTypes, string>> = {
  [JourneyTypes.MENOPAUSE]: DbgPaths.MENOPAUSE,
  [JourneyTypes.LOW_TESTOSTERONE]: DbgPaths.LOW_TESTOSTERONE,
  [JourneyTypes.GENDER_AFFIRMING_CARE]: DbgPaths.GENDER_AFFIRMING_CARE
}

export function CarrotCardCantBeUsedStep(): JSX.Element {
  const intl = useIntl()
  const {
    formState: { journeyType }
  } = useContext(CarrotCardCostSharePreAuthContext)

  const eligibleExpensesPath = journeyEligibleExpensesPaths[journeyType as JourneyTypes] ?? DbgPaths.CARROT_ELIGIBLE

  return (
    <WarningStep
      title={intl.formatMessage({ defaultMessage: "Carrot Card can’t be used for this expense." })}
      primaryDescription={intl.formatMessage(
        {
          defaultMessage:
            "However, you can use another payment method for <link>eligible expenses</link> and submit a reimbursement request. "
        },
        {
          link: (linkContent) => (
            <Link
              component={RouterLink}
              to={eligibleExpensesPath}
              color="inherit"
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkContent}
            </Link>
          )
        }
      )}
      secondaryDescription={intl.formatMessage(
        {
          defaultMessage: "Please <link>contact us</link> with any questions."
        },
        {
          link: (linkContent) => (
            <Link component={RouterLink} to="/care-team" color="inherit" target="_blank" rel="noopener noreferrer">
              {linkContent}
            </Link>
          )
        }
      )}
    />
  )
}
